module.exports = __webpack_public_path__ + "static/img/aboutUS_ggpydq.68eb004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1/aboutUS_ggpydq.png
// module id = x8VS
// module chunks = 1